// extracted by mini-css-extract-plugin
export var centerText = "_6r-8";
export var container = "_6r-0";
export var doughnutContainer = "_6r-7";
export var legend = "_6r-a";
export var legendItemColorDisplay = "_6r-b";
export var legendItemLabel = "_6r-d";
export var legendItemValue = "_6r-c";
export var lg = "_6r-5";
export var maxWidth = "_6r-9";
export var md = "_6r-4";
export var responsive = "_6r-6";
export var sm = "_6r-3";
export var xs = "_6r-2";
export var xxs = "_6r-1";